import { useState, useCallback, useEffect, useRef } from "react";

export default function useCarousel(nodesCount = 0) {
  const [step, setStep] = useState(0);
  const [prev, setPrev] = useState(false);
  const [next, setNext] = useState(false);

  // Ref для хранения текущего DOM элемента
  const currentNodeRef = useRef(null);

  const rootRef = useCallback(
    (node) => {
      currentNodeRef.current = node;

      if (!node) return;

      const { scrollWidth, clientWidth } = node;

      const left = step * clientWidth;
      const right = left + clientWidth;

      if (node.scroll) {
        node.scroll({
          top: 0,
          left,
          behavior: "smooth",
        });
      } else {
        node.scrollTo(0, left);
      }

      if (left > 0) {
        setPrev(true);
      } else {
        setPrev(false);
      }

      // Добавляем небольшой tolerance для более надежной проверки
      if (right < scrollWidth - 1) {
        setNext(true);
      } else {
        setNext(false);
      }
    },
    [step]
  );

  // Обновляем состояние кнопок при изменении количества элементов
  useEffect(() => {
    if (currentNodeRef.current && nodesCount > 0) {
      const node = currentNodeRef.current;
      const { scrollWidth, clientWidth, scrollLeft } = node;
      const scrollRight = scrollLeft + clientWidth;

      if (scrollLeft > 0) {
        setPrev(true);
      } else {
        setPrev(false);
      }

      // Проверяем есть ли контент справа для скролла
      if (scrollRight >= scrollWidth - 2) {
        setNext(false);
      } else {
        setNext(true);
      }
    }
  }, [nodesCount]);

  const onScroll = useCallback((event) => {
    const { scrollWidth, scrollLeft, clientWidth } = event.target;
    const scrollRight = scrollLeft + clientWidth;

    if (scrollLeft > 0) {
      setPrev(true);
    } else {
      setPrev(false);
    }

    // Добавляем tolerance в 2 пикселя для более надежной проверки достижения конца
    if (scrollRight >= scrollWidth - 2) {
      setNext(false);
    } else {
      setNext(true);
    }
  }, []);

  const onClickPrev = () => {
    setStep((step) => step - 1);
  };

  const onClickNext = () => {
    setStep((step) => step + 1);
  };

  return { step, prev, next, rootRef, onScroll, onClickPrev, onClickNext };
}
